import axios from 'axios';

import { apiUrl, config } from '../Shared/config';


export const createScenario = async (scenario, isPrivate = false) => {

  // console.log("8 - scenario=", scenario);
  // console.log("9 - isPrivate=", isPrivate);

  try {
    const { data } = await axios.post(apiUrl + 'reporting/scenarios', { scenario, isPrivate }, config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'error'; }
};


export const updateScenario = async (scenario) => {
  try {
    const { data } = await axios.put(apiUrl + 'reporting/scenarios', { scenario }, config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'error'; }
};


export const deleteScenario = async (id) => {
  try {
    const { data } = await axios.delete(apiUrl + 'reporting/scenarios/id=' + id, config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'error'; }
};


export const getScenario = async (id) => {
  try {
    const { data } = await axios.get(apiUrl + 'reporting/scenarios/id=' + id, config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'error'; }
};


export const getScenarios = async (locations, usage = 0) => {
  try {
    const { data } = await axios.post(apiUrl + 'reporting/scenarios/locations', { locations, usage }, config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'error'; }
};


export const getModuleDataName = async (moduleId) => {
  return;
  
  try {
    const { data } = await axios.post(apiUrl + 'reporting/scenarios/moduledata', { moduleId }, config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'error'; }
};